import React from "react";

export default function Button({
  children,
  onClick,
  className,
  disabled,
  style,
}) {
  return (
    <button
      className={`button common-width ${className} ${
        disabled ? "disabled" : ""
      }`}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      <span className="btn-text">{children}</span>
    </button>
  );
}
